import AclName from '../acl/AclName';
import model from '../models-v2/invoice/number-template';
import { INVOICE_NUMBER_TEMPLATE_ADD_URL, INVOICE_NUMBER_TEMPLATE_LIST_URL } from '../models-v2/invoice/number-template/url.js';

export default [
  {
    path: INVOICE_NUMBER_TEMPLATE_LIST_URL,
    name: 'invoices-number-templates-list',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      acl: AclName.SettingsPageInvoiceTemplateNumberList,
      rule: 'editor',
      search: false,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Szablony', url: '' },
        { title: 'Numeracja faktur', url: INVOICE_NUMBER_TEMPLATE_LIST_URL },
      ],
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: INVOICE_NUMBER_TEMPLATE_ADD_URL,
    name: 'invoices-number-templates-add',
    components: {
      default: () => import('../pages/model-form.vue'),
    },
    meta: {
      acl: AclName.SettingsPageInvoiceTemplateNumberAdd,
      rule: 'editor',
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Szablony', url: '' },
        { title: 'Numeracja faktur', url: INVOICE_NUMBER_TEMPLATE_LIST_URL },
        { title: 'Dodawanie', url: '' },
      ],
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
  },
  {
    path: '/admin/templates/invoice-numbers-templates/:id(\\d+)/start-number',
    name: 'invoices-number-templates-start-number',
    components: {
      default: () => import('../views/pages/invoice-number/change-number-page.vue'),

    },
    props: {
      default: ({ params }) => {
        return { ...params };
      },
    },
    meta: {
      acl: AclName.SettingsPageInvoiceTemplateNumberChangeNumber,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Szablony', url: '' },
        { title: 'Numeracja faktur', url: INVOICE_NUMBER_TEMPLATE_LIST_URL },
        { title: 'Edycja', url: '' },
      ],
    },
  },
];
